import type { Session } from '@supabase/supabase-js';
import type { AuthUser } from './types';

export const SESSION_HINT_KEY = 'fyle-session-hint';
export const SESSION_HINT_TTL = 5 * 60 * 1000;
export const USER_STATE_STORAGE_KEY = 'fyle-user-state';
export const SESSION_CACHE_TTL = 5 * 60 * 1000;

export const authCache = {
  authListenerSetup: false,
  suspensionListenerSetup: false,
  sessionCache: null as { session: Session | null; timestamp: number } | null,
  pendingMfaAccessToken: null as string | null,
  userStateCache: null as AuthUser | null,
};

export function schedulePrefetch(): void {
  import('../../stores/prefetchAppData').then((m) => m.prefetchAppData()).catch(() => {});
}
